<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import Service from '../../../../domain/documento/services/documento'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'
  import ImportProgress from './ImportProgress'

  export default {
    components: {
      ImportProgress,
      UPagination
    },
    nome: 'documentos',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        showFiltros: false,
        isLoading: false,
        data: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: ''
        },
        filterKey: '',
        sortKey: '',
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        prevent: {},
        dblclick: 0,
        isUploadingImport: false,
        activeImport: false,
        importStatus: {
          percent: 0,
          finish: false,
          mostrarErros: false,
          historico: {
            analisados: 0,
            cadastros: 0,
            erros: 0,
            remocoes: 0,
            logErros: null
          }
        }
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      noData () {
        let data = 'data'
        if (this[data] === null) {
          return false
        }
        if (this[data].length === 0) {
          return true
        }
        return false
      }
    },
    mounted () {
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    methods: {
      reload () {
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id) {
        /* this.dblclick++
        if (this.dblclick === 1) {
          let self = this
          this.timer = setTimeout(function () {
            self.dblclick = 0
          }, 500)
        } else {
          clearTimeout(this.timer)
          this.$router.push({name: 'documentos.visualizar', params: {id: id}})
          this.dblclick = 0
        } */
        this.$router.push({name: 'documento.editar', params: {id: id}})
      },

      load (limit, page, filtros) {
        this.data = null
        this.isLoading = true
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.data = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        this.pagination.atualPage = page
        this.load(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) { /* TODO: Refact / Reuse CheckALL */
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.data, key, Object.assign({}, this.data[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          if (this.checkeds < this.data.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        console.log(filtros.tipoPessoa, String(filtros.tipoPessoa).length)
        if (String(filtros.tipoPessoa).length > 0) {
          mount += '&tipo=' + filtros.tipoPessoa
        }
        if (Array.isArray(filtros.situacaoCadastro) && filtros.situacaoCadastro.length > 0) {
          mount += '&status=' + filtros.situacaoCadastro.join(',')
        }
        return mount
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),
      deleteItems () {
        let items = this.data.filter(e => e.selected).map(e => e.id).join(',')
        this.$loaderOverlay.open().message('Aguarde enquanto os documentos são deletados')
        Service.deleteDocumentoList(items)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.data = this.data.filter(e => !e.selected)
            alert('Documentos deletados com sucesso')
            // this.reload()
            console.log(response)
          })
          .catch((error) => {
            this.$loaderOverlay.hide()
            alert('Não foi possível deletar os documentos')
            console.log(error)
          })
      },
      importar (e) {
        this.isUploadingImport = true
        this.activeImport = true
        this.importStatus.finish = false
        let formData = new FormData()
        formData.append('file', e.target.files[0], e.target.files[0].name)
        e.target.value = ''
        Service.importar(formData, (e) => {
          console.log('Upload in progress...')
          console.log(e)
          let percent = e.loaded / e.total * 100
          this.importStatus.percent = percent
          if (percent >= 100) {
            window.setTimeout(() => {
              this.isUploadingImport = false
            }, 1000)
          }
        })
          .then((response) => {
            window.setTimeout(() => {
              this.isUploadingImport = false
              this.importStatus.finish = true
              this.importStatus.historico = response.data.historico
            }, 1000)
            console.log(response)
          })
          .catch((response) => {
            this.isUploadingImport = false
            window.alert('Não foi possível importar, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Entrega de Documentos <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'documento.novo'}" tag="button" class="btn btn-default btn-sm "><i
                      class="fa fa-plus"></i>
                      Novo Documento
                    </router-link>
                    <!--<button class="btn btn-default btn-sm m-l-xs ">
                      <i class="glyphicon glyphicon-import"></i> Importar
                    </button>-->
                    <u-button :disabled="isUploadingImport" class="btn btn-default btn-sm fileContainer hidden-print">
                      <i class="glyphicon glyphicon-import"></i> Importar
                      <input @change="importar"
                             accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                             type="file"/>
                    </u-button>

                  </div>
                </div>
              </div>
              <transition name="slide" appear>
                <div class="wrapper content-transition" v-if="activeImport">
                  <transition name="slide2">
                    <div class="content-transition" v-if="isUploadingImport">
                      <h4 class="text-center">Importando</h4>
                      <import-progress :percent="importStatus.percent"></import-progress>
                    </div>
                  </transition>
                  <transition name="slide2">
                    <div class="content-transition text-center"
                         v-if="!isUploadingImport && activeImport && !importStatus.finish">
                      <div><i class="fa fa-spinner fa-spin"></i></div>
                      Processando
                    </div>
                  </transition>
                  <transition name="slide2">
                    <div class="content-transition text-left" v-if="importStatus.finish">
                      <table class="table table-bordered table-condensed table-striped">
                        <tbody>
                        <tr>
                          <td>Analisados</td>
                          <td class="font-bold">{{ importStatus.historico.analisados }}</td>
                        </tr>
                        <tr>
                          <td>Cadastros</td>
                          <td class="font-bold">{{ importStatus.historico.cadastros }}</td>
                        </tr>
                        <tr>
                          <td>Remoções</td>
                          <td class="font-bold">{{ importStatus.historico.remocoes }}</td>
                        </tr>
                        <tr>
                          <td>Erros</td>
                          <td class="font-bold">
                            {{ importStatus.historico.erros }}
                            <a v-if="importStatus.historico.erros > 0" class="text-danger m-l-xs" @click="importStatus.mostrarErros = !importStatus.mostrarErros">{{ importStatus.mostrarErros ? 'ocultar' : 'mostrar' }} erros</a></td>
                        </tr>
                        </tbody>
                      </table>
                      <table v-if="importStatus.mostrarErros" class="table">
                        <tbody>
                        <tr v-for="erro in importStatus.historico.logErros">
                          <td>{{ erro }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </transition>
                </div>
              </transition>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <button class="btn btn-sm btn-default" @click="deleteItems" :disabled="checkeds < 1">Deletar
                  </button>
                </div>
                <div class="col-sm-5">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <!--<div class="wrapper m-b-n m-t-n text-right">
                <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                              :total="pagination.totalPages"></u-pagination>
              </div>-->
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(data)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>ID</th>
                    <th>Código / Lote</th>
                    <th>Placa</th>
                    <th>Pessoa</th>
                    <th>Documento</th>
                    <th>Leilão</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr :title="doc.manualDescricao" v-for="doc in filteredData">
                    <td class="v-middle"><label
                      class="i-checks m-b-none"><input v-on:click.stop="lazyCheck(doc)" type="checkbox"
                                                       name="post[]"
                                                       v-model="doc.selected"
                                                       tabindex="0" aria-checked="false"
                                                       aria-invalid="false"><i></i></label></td>
                    <td @click="open(doc.id)" role="button" tabindex="0">{{ doc.id }}</td>
                    <td @click="open(doc.id)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ doc.codigo }} / LT {{ doc.manualLote }}</a>
                    </td>
                    <td @click="open(doc.id)" role="button" tabindex="0">
                      {{ doc.manualPlaca }}
                    </td>
                    <td @click="open(doc.id)" role="button" tabindex="0">
                      {{ doc.manualNome }}
                    </td>
                    <td @click="open(doc.id)" role="button" tabindex="0">
                      <span v-if="doc.manualDocumento.length === 11">{{ doc.manualDocumento | formataCpf }}</span>
                      <span v-else-if="doc.manualDocumento.length === 14">{{ doc.manualDocumento | formataCnpj }}</span>
                      <span v-else>{{ doc.manualDocumento }}</span>
                    </td>
                    <td @click="open(doc.id)" role="button" tabindex="0">
                      {{ doc.manualDataLeilao && doc.manualDataLeilao.date &&
                      moment(doc.manualDataLeilao.date).format('L') }}
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="7">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>


    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Documentos.vue?1dd22aa6